import React from 'react';
import styled from 'styled-components';
import { TitleContainer } from 'components/atoms/module-settings/advanced-settings';
import { SettingsLabelWithoutMargin } from '../../styles';

const Icon = styled.div`
  flex: 0 0 var(--layout-03);
  display: flex;
  align-items: center;
`;

export const SettingHeader = ({
  icon,
  title,
}: {
  icon: JSX.Element;
  title: string;
}) => {
  return (
    <TitleContainer>
      <Icon>{icon}</Icon>
      <SettingsLabelWithoutMargin>{title}</SettingsLabelWithoutMargin>
    </TitleContainer>
  );
};
